// @flow
import { styled } from 'mz-ui-kit'

// Constants
const CONTAINER_PLACEMENT = {
  top: { marginBottom: '3px' },
  bottom: { marginTop: '3px' },
  left: { marginRight: '3px' },
  right: { marginLeft: '3px' },
}

// Container for the options which will be positioned with popper
export const Container = styled<{
  $placement: 'top' | 'bottom' | 'left' | 'right',
  $showed?: boolean,
  $width: string,
  $minWidth?: string,
  $maxWidth?: string,
}>('div', ({ $placement, $showed, $width, $minWidth, $maxWidth }) => ({
  zIndex: 100000,
  width: $width,
  maxWidth: $maxWidth || 'none',
  minWidth: $minWidth || 'none',
  pointerEvents: $showed ? 'inherit' : 'none',
  ...CONTAINER_PLACEMENT[$placement],
}))

// List of options, which addds some styles around the list and
// nice fade-in-out animation
export const DefaultOptionsList = styled<{
  $showed?: boolean,
  $maxHeight?: string,
}>('div', ({ $showed, $maxHeight, $palette }) => ({
  boxShadow: '0px 3px 5px 0px rgba(0,0,0,0.2)',
  transform: $showed ? 'translate3d(0,0,0)' : 'translate3d(0,-6px,0)',
  opacity: $showed ? 1 : 0,
  background: `${$palette('white')}`,
  borderRadius: '3px',
  borderStyle: 'solid',
  borderColor: `${$palette('gray')}`,
  borderWidth: '1px',
  transition: 'all 430ms cubic-bezier(0.165, 0.84, 0.44, 1)',
  maxHeight: $maxHeight || 'inherit',
}))

// Default option wrapper component
export const DefaultOptionWrapper = styled<{
  $focused?: boolean,
}>('div', ({ $focused, $palette }) => ({
  userSelect: 'none',
  position: 'relative',
  cursor: 'pointer',
  padding: '10px',
  ...(!$focused
    ? {}
    : {
        outline: 0,
        backgroundColor: `${$palette('gray').lighten(8)}`,
        zIndex: 10,
      }),
  ':active': {
    backgroundColor: `${$palette('primary')} !important`,
    color: `${$palette('white')}`,
  },
  ':hover': {
    backgroundColor: `${$palette('gray').lighten(8)}`,
  },
}))

export const OptionsLoadingWrapper = styled<{
  $loading?: boolean,
}>('div', ({ $loading }) => ({
  transition: 'all 430ms cubic-bezier(0.165, 0.84, 0.44, 1)',
  pointerEvents: $loading ? 'none' : 'inherit',
  opacity: $loading ? 0.4 : 1,
}))
